var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,1.25,-39.875,-37.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07411,0,0,1,-2.36423,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125,30L31.9,63.2L46.1,186.3L125,230L203.9,186.3L218.1,63.2L125,30Z",
    style: {
      fill: "rgb(221,0,49)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07411,0,0,1,-2.36423,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125,30L125,52.2L125,52.1L125,230L203.9,186.3L218.1,63.2L125,30Z",
    style: {
      fill: "rgb(195,0,47)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07411,0,0,1,-2.36423,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125,52.1L66.8,182.6L88.5,182.6L100.2,153.4L149.6,153.4L161.3,182.6L183,182.6L125,52.1ZM142,135.4L108,135.4L125,94.5L142,135.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.dfcc25a90047fde50312d61139b7995d.svg";
export { ForwardRef as ReactComponent };